import {createContext} from "react";

export const AppTranslationsContext = createContext(null);
